module.exports = __webpack_public_path__ + "img/animated-pup2.997e49cc.gif";